import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";

export default function useAgency() {

    const isProduction = usePage().props.__isProduction;


    const agency = computed(() => usePage().props.__agency);

    const agent = computed(() => usePage().props.__agent);

    const agencyId = computed(() => usePage().props.__agencyId);


    const hasAgency = computed(() => !!agency.value)

    const getOrderUrl = function () {
        var orderUrl = `${agency.value?.resmarkUrl}/public/order/index/Order/view`;


        if (!isProduction) {
            // Replace app with sandbox for non-production environments
            orderUrl = orderUrl.replace('.app.', '.sandbox.');

        }


        return orderUrl;
    };

    return { agency, agent, hasAgency, getOrderUrl, agencyId };
}
